var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConfettiCannon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 49,
  height: 50,
  fill: "none",
  viewBox: "0 0 49 50"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m15 14.5-14 34 33-14.209"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeWidth: 2,
  d: "M26.556 22.157c2.886 2.886 5.16 5.786 6.514 8.122.68 1.175 1.097 2.157 1.264 2.892.18.793.009.998 0 1.007s-.213.179-1.006-.001c-.735-.167-1.717-.584-2.892-1.264C28.1 31.56 25.2 29.285 22.314 26.4c-2.886-2.886-5.16-5.786-6.514-8.123-.68-1.175-1.097-2.157-1.264-2.892-.18-.793-.009-.998 0-1.006s.213-.18 1.006 0c.735.167 1.717.585 2.892 1.265 2.336 1.352 5.237 3.627 8.122 6.513Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M7 35.5c2.754 2.411 2.284 7 .857 10M10 27.5c4.748 3.895 4.687 9.974 2.811 15M20 24.504c2.25 5.551.937 11.783-2.5 16.897"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00AED9",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M27.975.992c.123 7.602-2.383 12.71-6.571 17.944"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 19.5,
  r: 2,
  stroke: "#00AED9",
  strokeWidth: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 6.5,
  r: 2,
  stroke: "#00AED9",
  strokeWidth: 2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 2.5,
  r: 1,
  fill: "#00AED9"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 8.5,
  r: 1,
  fill: "#00AED9"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 8.5,
  r: 1,
  fill: "#00AED9"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 30.5,
  r: 1,
  fill: "#00AED9"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 36.5,
  r: 1,
  fill: "#00AED9"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 29.5,
  r: 1,
  fill: "#00AED9"
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 3.5,
  r: 2,
  stroke: "#00AED9",
  strokeWidth: 2
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00AED9",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M38 38.5v6M33 13.5v6M35 41.5h6M30 16.5h6M38.762 25.435c-3.012-.098-6.005.792-8.972 2.917"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M15.443 26.461c-.63-1.24-1.513-2.711-3.404-4.518"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00AED9",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M7 7.5v6M4 10.5h6M43.993 10.238c-1.458.282-3.018.767-4.888 2.26"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M27.428 31.599c.665 2.449-.911 4.827-1.778 5.747"
})));
export default SvgConfettiCannon;